module.exports = __webpack_public_path__ + "img/icon(14).a46f7211.png";